import axios from 'axios';

const list = (page, start, end) => {
    return axios({
        method: 'get',
        url: `${ process.env.VUE_APP_API_URL }/Dashboard/ChangeLogs?pageSize=16&page=${ page }&from=${ start }&to=${ end }`,
        withCredentials: true,
    });
};

export default {
    list,
};
